import React, { FormEvent, useState, useEffect } from 'react';
import useTranslate from '../../i18n/useTranslate';
import DotFalling from '../reusable/spinner/DotFalling';
import { useAppDispatch } from '@src/core/hooks';
import {
  setResendEmail,
  validCode,
  sendingFormSelector,
  passwordRecoveryEmailSelector,
  setErrors,
} from '../../features/auth';
import styled from 'styled-components';
import { BodyRegular } from '@src/fonts/typography/Typography';
import {
  AuthContainer,
  AuthForm,
  AuthHeader,
  AuthHeaderTitle,
  AuthHeaderSubtitle,
  AuthButtonGroup,
  AuthPrimaryButton,
  AuthPreviousStepButton,
} from './StyledComponents/AuthStyled';
import { LayoutColors } from '@src/core/theme';
import { useAppSelector } from '../../core/hooks';
import { VALID_CODE } from './ForgotPassword';
import InputCode from './InputComponents/InputCode';
import { track } from '@src/services/analytics';

interface ValidCodeProps {
  onBack: () => void;
}
const ValidCode = ({ onBack }: ValidCodeProps) => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslate();
  const loading = useAppSelector(sendingFormSelector);
  const passwordRecoveryEmail = useAppSelector(passwordRecoveryEmailSelector);
  const [codeOTP, setCodeOTP] = useState('');

  useEffect(() => {
    dispatch(setErrors(VALID_CODE, {}));

    track('recoveryPasswordCodeStepAccess');
  }, []);

  const handleResendEmail = () => {
    dispatch(setResendEmail(true));
  };

  const handleSubmit = (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    track('recoveryPasswordCodeStepSubmit');

    dispatch(
      validCode({
        email: passwordRecoveryEmail ?? '',
        code: codeOTP,
      }),
    );
  };

  return (
    <AuthContainer>
      <AuthForm key={VALID_CODE} onSubmit={handleSubmit}>
        <AuthHeader>
          <AuthHeaderTitle>{i18n('auth_recoverPassword')}</AuthHeaderTitle>
          <AuthHeaderSubtitle>
            {i18n('auth_validCodeSubtitle')}
            <strong> {passwordRecoveryEmail}</strong>
          </AuthHeaderSubtitle>
          <InputCode label={i18n('auth_code')} errorContext={VALID_CODE} setCodeOTP={setCodeOTP} codeOTP={codeOTP} />
          <AuthButtonGroup>
            <AuthPrimaryButton>{loading ? <DotFalling /> : i18n('auth_continue')}</AuthPrimaryButton>
            <InfoResendEmail>
              {i18n('auth_didNotGetTheEmail')}
              <LinkResendEmail onClick={handleResendEmail}>{i18n('auth_clickHere')}</LinkResendEmail>
            </InfoResendEmail>
            <AuthPreviousStepButton onClick={() => onBack()}>{i18n('auth_goBackButton')}</AuthPreviousStepButton>
          </AuthButtonGroup>
        </AuthHeader>
      </AuthForm>
    </AuthContainer>
  );
};

const InfoResendEmail = styled.div`
  ${BodyRegular};
  display: block;
  width: 100%;
`;

const LinkResendEmail = styled.a`
  font-size: inherit;
  color: ${LayoutColors.justBlue};
  padding-left: 5px;
  text-decoration: none;
  cursor: pointer;
`;

export default ValidCode;
